module.exports = __webpack_public_path__ + "static/media/menu-burger-icon-mob.a95ceba6.svg";